import { render } from "./TheTemplateL.vue?vue&type=template&id=3949dbe8&scoped=true&ts=true"
import script from "./TheTemplateL.vue?vue&type=script&lang=ts"
export * from "./TheTemplateL.vue?vue&type=script&lang=ts"

import "./TheTemplateL.vue?vue&type=style&index=0&id=3949dbe8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3949dbe8"]])

export default __exports__